import * as React from "react";
import { dropdownViewGet } from "../service/api-service";
import { Dropdown } from "primereact/dropdown";
import { FormControl, FormLabel } from "@mui/joy";

interface inputPrams {
  label: string;
  apiPath: string;
  optionLabel: string;
  optionValue: string;
  selectedData?: string | number;
  setSelectedData: React.Dispatch<any>;
  setSelectedObject?: React.Dispatch<any>;
  queryParams?: any;
  required?: boolean;
  FormControlError?: any;
  disabled?: boolean;
  allowAll?: boolean;
}

export default function DropdownApi(params: inputPrams) {
  const {
    label,
    apiPath,
    optionLabel,
    optionValue,
    selectedData,
    setSelectedData,
    setSelectedObject,
    queryParams,
    required,
    FormControlError,
    disabled,
    allowAll,
  } = params;
  const [data, setData] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(false);

  const loadLazyData = () => {
    if (!loading) {
      setLoading(true);
      dropdownViewGet(apiPath, queryParams)
        .then(data => {
          console.log("dropdownViewGet == ", data);
          const records = allowAll ? data : data.filter(e => (e[optionLabel] as string).toLowerCase() != "all");
          setData(records);
        })
        .catch(error => {
          console.log("error == ", error);
          setData([]);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const setSelected = (event: any) => {
    setSelectedData(event);
    if (setSelectedObject) {
      const obj = data.find(e => e[optionValue] == event);
      setSelectedObject(obj);
    }
  };

  React.useEffect(() => {
    loadLazyData();
  }, [queryParams]);

  // Get valid selected value only if it exists in current options
  const getValidSelectedValue = () => {
    if (!selectedData || !data.length) return selectedData;
    
    const valueExists = data.some(option => option[optionValue] === selectedData);
    
    return valueExists ? selectedData : undefined;
  };

  return (
    <FormControl error={FormControlError}>
      <FormLabel>
        {label}
        {required ? <div style={{ color: "red" }}>*</div> : ""}
      </FormLabel>
      {data?.length > 0 ? (
        <Dropdown
          className="PrimeSmallInput"
          style={{ fontSize: "small", padding: 0 }}
          onChange={(e: any) => setSelected(e.value)}
          value={getValidSelectedValue()}
          options={data}
          optionLabel={optionLabel}
          optionValue={optionValue}
          filter
          showClear
          filterBy={optionLabel}
          placeholder={`Select ${label}`}
          panelClassName="custom-dropdown-panel"
          disabled={disabled}
        />
      ) : (
        <Dropdown
          className="PrimeSmallInput"
          style={{ fontSize: "small", padding: 0 }}
          placeholder={`Select ${label}`}
          options={[]}
          loading={loading}
          disabled={disabled}
          panelClassName="custom-dropdown-panel"
        />
      )}
    </FormControl>
  );
}
